export default "__VITE_ASSET__09hzJeRF__"